import { Box, Typography } from "@mui/material";
import React from "react";
import styles from "../css/GadgetInfoTopic.module.css";

interface GadgetInfoTopicProps {
    header: string
    description?: string,
    icon: React.ReactNode,
    dataTestId: string
}

export const GadgetInfoTopic = ({header, description, icon, dataTestId}: GadgetInfoTopicProps) => {
  return (
    <Box>
      <div className={styles.headerContainer}>
        {icon}
        <Typography variant="h4" className={styles.headerText}>{header}</Typography>
      </div>
      {description && <Typography variant="body2" className={styles.descriptionText} data-testid={dataTestId}>{description}</Typography>}
    </Box>
  );
};